/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: zYoTgxRpN7IY
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  get as $stateGet,
  set as $stateSet,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import AvatarPartner from "../../AvatarPartner"; // plasmic-import: D4gHgvC_20mV/component
import PartnerAvatarPannel from "../../PartnerAvatarPannel"; // plasmic-import: Nxr1hsnMCUh9/component
import PartnerAvatarPannelPlaceholder from "../../PartnerAvatarPannelPlaceholder"; // plasmic-import: 4cC-CjBM0Irp/component
import ButtonActionPictogram from "../../ButtonActionPictogram"; // plasmic-import: NdapmL4tQ5kp/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicWidgetPeopleWall.module.css"; // plasmic-import: zYoTgxRpN7IY/css
import Icon28Icon from "./icons/PlasmicIcon__Icon28"; // plasmic-import: UArBRslF3jXM/icon
import image8KTo8Rg8U39Nh from "./images/image8.svg"; // plasmic-import: KTo8rg8u39NH/picture

createPlasmicElementProxy;

export const PlasmicWidgetPeopleWall__VariantProps = new Array();

export const PlasmicWidgetPeopleWall__ArgProps = new Array();

const $$ = {};

function PlasmicWidgetPeopleWall__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "isProfilePannelVisible",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "isPlaceholderPannelVisible",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"widgetWrapper"}
      data-plasmic-override={overrides.widgetWrapper}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.widgetWrapper
      )}
    >
      <div
        data-plasmic-name={"missionWrapp"}
        data-plasmic-override={overrides.missionWrapp}
        className={classNames(projectcss.all, sty.missionWrapp)}
      >
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__s5Jd3
          )}
        >
          {"MISSION."}
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text___0F9It
          )}
        >
          {
            "Empower the independent to navigate the 21st century without sacrificing autonomy or compromising who they are."
          }
        </div>
      </div>
      <div
        data-plasmic-name={"membersWrapp"}
        data-plasmic-override={overrides.membersWrapp}
        className={classNames(projectcss.all, sty.membersWrapp)}
      >
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__vlbvH
          )}
        >
          {"MEMBERS."}
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__sdBm6)}>
          <div className={classNames(projectcss.all, sty.freeBox__kKm45)}>
            <AvatarPartner
              className={classNames("__wab_instance", sty.avatarPartner__wYpl)}
              isSelected={(() => {
                try {
                  return $state.isProfilePannelVisible;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return [];
                  }
                  throw e;
                }
              })()}
              onClick={async () => {
                const $steps = {};
                $steps["updateIsProfilePannelVisible"] = true
                  ? (() => {
                      const actionArgs = {
                        variable: {
                          objRoot: $state,
                          variablePath: ["isProfilePannelVisible"]
                        },
                        operation: 4
                      };
                      return (({
                        variable,
                        value,
                        startIndex,
                        deleteCount
                      }) => {
                        if (!variable) {
                          return;
                        }
                        const { objRoot, variablePath } = variable;
                        const oldValue = $stateGet(objRoot, variablePath);
                        $stateSet(objRoot, variablePath, !oldValue);
                        return !oldValue;
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["updateIsProfilePannelVisible"] != null &&
                  typeof $steps["updateIsProfilePannelVisible"] === "object" &&
                  typeof $steps["updateIsProfilePannelVisible"].then ===
                    "function"
                ) {
                  $steps["updateIsProfilePannelVisible"] =
                    await $steps["updateIsProfilePannelVisible"];
                }
                $steps["updateIsProfilePannelVisible2"] = true
                  ? (() => {
                      const actionArgs = {
                        variable: {
                          objRoot: $state,
                          variablePath: ["isPlaceholderPannelVisible"]
                        },
                        operation: 1
                      };
                      return (({
                        variable,
                        value,
                        startIndex,
                        deleteCount
                      }) => {
                        if (!variable) {
                          return;
                        }
                        const { objRoot, variablePath } = variable;
                        $stateSet(objRoot, variablePath, undefined);
                        return undefined;
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["updateIsProfilePannelVisible2"] != null &&
                  typeof $steps["updateIsProfilePannelVisible2"] === "object" &&
                  typeof $steps["updateIsProfilePannelVisible2"].then ===
                    "function"
                ) {
                  $steps["updateIsProfilePannelVisible2"] =
                    await $steps["updateIsProfilePannelVisible2"];
                }
              }}
            >
              <Icon28Icon
                className={classNames(projectcss.all, sty.svg__mL8Cs)}
                role={"img"}
              />
            </AvatarPartner>
            <AvatarPartner
              className={classNames("__wab_instance", sty.avatarPartner__nBapZ)}
              isSelected={(() => {
                try {
                  return $state.isPlaceholderPannelVisible;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return [];
                  }
                  throw e;
                }
              })()}
              onClick={async () => {
                const $steps = {};
                $steps["updateIsPlaceholderProfileVisible"] = true
                  ? (() => {
                      const actionArgs = {
                        variable: {
                          objRoot: $state,
                          variablePath: ["isPlaceholderPannelVisible"]
                        },
                        operation: 4
                      };
                      return (({
                        variable,
                        value,
                        startIndex,
                        deleteCount
                      }) => {
                        if (!variable) {
                          return;
                        }
                        const { objRoot, variablePath } = variable;
                        const oldValue = $stateGet(objRoot, variablePath);
                        $stateSet(objRoot, variablePath, !oldValue);
                        return !oldValue;
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["updateIsPlaceholderProfileVisible"] != null &&
                  typeof $steps["updateIsPlaceholderProfileVisible"] ===
                    "object" &&
                  typeof $steps["updateIsPlaceholderProfileVisible"].then ===
                    "function"
                ) {
                  $steps["updateIsPlaceholderProfileVisible"] =
                    await $steps["updateIsPlaceholderProfileVisible"];
                }
                $steps["updateIsProfilePannelVisible"] = true
                  ? (() => {
                      const actionArgs = {
                        variable: {
                          objRoot: $state,
                          variablePath: ["isProfilePannelVisible"]
                        },
                        operation: 1
                      };
                      return (({
                        variable,
                        value,
                        startIndex,
                        deleteCount
                      }) => {
                        if (!variable) {
                          return;
                        }
                        const { objRoot, variablePath } = variable;
                        $stateSet(objRoot, variablePath, undefined);
                        return undefined;
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["updateIsProfilePannelVisible"] != null &&
                  typeof $steps["updateIsProfilePannelVisible"] === "object" &&
                  typeof $steps["updateIsProfilePannelVisible"].then ===
                    "function"
                ) {
                  $steps["updateIsProfilePannelVisible"] =
                    await $steps["updateIsProfilePannelVisible"];
                }
              }}
            >
              <Icon28Icon
                className={classNames(projectcss.all, sty.svg__iRw95)}
                role={"img"}
              />
            </AvatarPartner>
            <AvatarPartner
              children={null}
              className={classNames(
                "__wab_instance",
                sty.avatarPartner___0R8Fn
              )}
              onClick={async () => {
                const $steps = {};
                $steps["updateIsProfilePannelVisible"] = true
                  ? (() => {
                      const actionArgs = {
                        variable: {
                          objRoot: $state,
                          variablePath: ["isProfilePannelVisible"]
                        },
                        operation: 1
                      };
                      return (({
                        variable,
                        value,
                        startIndex,
                        deleteCount
                      }) => {
                        if (!variable) {
                          return;
                        }
                        const { objRoot, variablePath } = variable;
                        $stateSet(objRoot, variablePath, undefined);
                        return undefined;
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["updateIsProfilePannelVisible"] != null &&
                  typeof $steps["updateIsProfilePannelVisible"] === "object" &&
                  typeof $steps["updateIsProfilePannelVisible"].then ===
                    "function"
                ) {
                  $steps["updateIsProfilePannelVisible"] =
                    await $steps["updateIsProfilePannelVisible"];
                }
                $steps["updateIsProfilePannelVisible2"] = true
                  ? (() => {
                      const actionArgs = {
                        variable: {
                          objRoot: $state,
                          variablePath: ["isPlaceholderPannelVisible"]
                        },
                        operation: 1
                      };
                      return (({
                        variable,
                        value,
                        startIndex,
                        deleteCount
                      }) => {
                        if (!variable) {
                          return;
                        }
                        const { objRoot, variablePath } = variable;
                        $stateSet(objRoot, variablePath, undefined);
                        return undefined;
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["updateIsProfilePannelVisible2"] != null &&
                  typeof $steps["updateIsProfilePannelVisible2"] === "object" &&
                  typeof $steps["updateIsProfilePannelVisible2"].then ===
                    "function"
                ) {
                  $steps["updateIsProfilePannelVisible2"] =
                    await $steps["updateIsProfilePannelVisible2"];
                }
              }}
            />

            <AvatarPartner
              children={null}
              className={classNames("__wab_instance", sty.avatarPartner__znEwo)}
            />

            <AvatarPartner
              children={null}
              className={classNames("__wab_instance", sty.avatarPartner__c8D3)}
            />
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__jfOl)}>
            <AvatarPartner
              children={null}
              className={classNames("__wab_instance", sty.avatarPartner__bXcm7)}
            />

            <AvatarPartner
              children={null}
              className={classNames("__wab_instance", sty.avatarPartner__aWl6I)}
            />

            <AvatarPartner
              children={null}
              className={classNames("__wab_instance", sty.avatarPartner__jlScK)}
            />

            <AvatarPartner
              children={null}
              className={classNames("__wab_instance", sty.avatarPartner__qwWo)}
            />

            <AvatarPartner
              children={null}
              className={classNames(
                "__wab_instance",
                sty.avatarPartner___0QKd5
              )}
            />
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__tuS1D)}>
            <AvatarPartner
              children={null}
              className={classNames("__wab_instance", sty.avatarPartner__pRjQ)}
            />

            <AvatarPartner
              children={null}
              className={classNames("__wab_instance", sty.avatarPartner__wWkCz)}
            />

            <AvatarPartner
              children={null}
              className={classNames("__wab_instance", sty.avatarPartner__dTOed)}
            />

            <AvatarPartner
              children={null}
              className={classNames(
                "__wab_instance",
                sty.avatarPartner___5WmmC
              )}
            />

            <AvatarPartner
              children={null}
              className={classNames("__wab_instance", sty.avatarPartner__cjDbm)}
            />
          </div>
        </div>
        <PartnerAvatarPannel
          data-plasmic-name={"partnerAvatarPannel"}
          data-plasmic-override={overrides.partnerAvatarPannel}
          className={classNames("__wab_instance", sty.partnerAvatarPannel)}
          isVisible={(() => {
            try {
              return $state.isProfilePannelVisible;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return [];
              }
              throw e;
            }
          })()}
        />

        <PartnerAvatarPannelPlaceholder
          data-plasmic-name={"partnerAvatarPannelPlaceholder"}
          data-plasmic-override={overrides.partnerAvatarPannelPlaceholder}
          actionsWrapp2={
            <ButtonActionPictogram
              data-plasmic-name={"buttonActionPictogram"}
              data-plasmic-override={overrides.buttonActionPictogram}
              className={classNames(
                "__wab_instance",
                sty.buttonActionPictogram
              )}
              color={"white"}
              iconActionButton={
                <PlasmicImg__
                  data-plasmic-name={"img"}
                  data-plasmic-override={overrides.img}
                  alt={""}
                  className={classNames(sty.img)}
                  displayHeight={"100%"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"none"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"100%"}
                  loading={"lazy"}
                  src={{
                    src: image8KTo8Rg8U39Nh,
                    fullWidth: 20,
                    fullHeight: 20,
                    aspectRatio: undefined
                  }}
                />
              }
              onClick={async () => {
                const $steps = {};
                $steps["updateIsPlaceholderPannelVisible"] = true
                  ? (() => {
                      const actionArgs = {
                        variable: {
                          objRoot: $state,
                          variablePath: ["isPlaceholderPannelVisible"]
                        },
                        operation: 1
                      };
                      return (({
                        variable,
                        value,
                        startIndex,
                        deleteCount
                      }) => {
                        if (!variable) {
                          return;
                        }
                        const { objRoot, variablePath } = variable;
                        $stateSet(objRoot, variablePath, undefined);
                        return undefined;
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["updateIsPlaceholderPannelVisible"] != null &&
                  typeof $steps["updateIsPlaceholderPannelVisible"] ===
                    "object" &&
                  typeof $steps["updateIsPlaceholderPannelVisible"].then ===
                    "function"
                ) {
                  $steps["updateIsPlaceholderPannelVisible"] =
                    await $steps["updateIsPlaceholderPannelVisible"];
                }
              }}
              size={"medium"}
              status={"normal"}
            />
          }
          className={classNames(
            "__wab_instance",
            sty.partnerAvatarPannelPlaceholder
          )}
          isVisible={(() => {
            try {
              return $state.isPlaceholderPannelVisible;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return [];
              }
              throw e;
            }
          })()}
        />
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  widgetWrapper: [
    "widgetWrapper",
    "missionWrapp",
    "membersWrapp",
    "partnerAvatarPannel",
    "partnerAvatarPannelPlaceholder",
    "buttonActionPictogram",
    "img"
  ],

  missionWrapp: ["missionWrapp"],
  membersWrapp: [
    "membersWrapp",
    "partnerAvatarPannel",
    "partnerAvatarPannelPlaceholder",
    "buttonActionPictogram",
    "img"
  ],

  partnerAvatarPannel: ["partnerAvatarPannel"],
  partnerAvatarPannelPlaceholder: [
    "partnerAvatarPannelPlaceholder",
    "buttonActionPictogram",
    "img"
  ],

  buttonActionPictogram: ["buttonActionPictogram", "img"],
  img: ["img"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWidgetPeopleWall__ArgProps,
          internalVariantPropNames: PlasmicWidgetPeopleWall__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWidgetPeopleWall__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "widgetWrapper") {
    func.displayName = "PlasmicWidgetPeopleWall";
  } else {
    func.displayName = `PlasmicWidgetPeopleWall.${nodeName}`;
  }
  return func;
}

export const PlasmicWidgetPeopleWall = Object.assign(
  // Top-level PlasmicWidgetPeopleWall renders the root element
  makeNodeComponent("widgetWrapper"),
  {
    // Helper components rendering sub-elements
    missionWrapp: makeNodeComponent("missionWrapp"),
    membersWrapp: makeNodeComponent("membersWrapp"),
    partnerAvatarPannel: makeNodeComponent("partnerAvatarPannel"),
    partnerAvatarPannelPlaceholder: makeNodeComponent(
      "partnerAvatarPannelPlaceholder"
    ),
    buttonActionPictogram: makeNodeComponent("buttonActionPictogram"),
    img: makeNodeComponent("img"),
    // Metadata about props expected for PlasmicWidgetPeopleWall
    internalVariantProps: PlasmicWidgetPeopleWall__VariantProps,
    internalArgProps: PlasmicWidgetPeopleWall__ArgProps
  }
);

export default PlasmicWidgetPeopleWall;
/* prettier-ignore-end */
